export default __webpack_public_path__ + "static/media/thumbsup.1dced519.svg";